var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68002 0.522531C3.13912 0.707076 2.12399 2.01397 2.19143 3.52411V3.52471C2.27856 5.24473 3.70666 6.44668 5.4069 6.24224C6.90602 6.06191 7.97487 4.77974 7.88595 3.20206C7.79225 1.54356 6.39458 0.316877 4.68002 0.522531ZM3.84502 11.4964C4.22665 11.4967 4.60826 11.497 4.98983 11.497H4.99043H8.0943C8.21846 11.497 8.34267 11.4973 8.46692 11.4976C8.74044 11.4982 9.01416 11.4989 9.28787 11.4964C9.73844 11.4921 10.0165 11.2039 9.99924 10.7516C9.99207 10.5513 9.97119 10.3505 9.93956 10.1527C9.79931 9.26916 9.40185 8.51831 8.7627 7.90316C7.99464 7.16377 7.05948 6.82484 6.01391 6.80433C5.22377 6.78925 4.43184 6.79347 3.64289 6.83449C2.80023 6.87851 2.04708 7.20297 1.40196 7.75239C0.583769 8.44835 0.137375 9.35118 0.0215983 10.4211C0.00130766 10.6092 -0.0130151 10.8052 0.0180177 10.9898C0.0609861 11.2467 0.330136 11.5018 0.737143 11.5C1.77294 11.4947 2.80905 11.4955 3.84502 11.4964Z",
    fill: "#232777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.291b9226295f208351595050b49e9d56.svg";
export { ForwardRef as ReactComponent };